import Vue from 'vue';
import { mapGetters } from 'vuex';
import { guid } from '@/mixins/guid';
import tooltip from '@/mixins/components/tooltip';
import TicketList from './ticket-list';

export default Vue.component('admin-support-tickets', {
  template: require('./template.html'),
  name: 'admin-support-tickets',
  mixins: [guid],
  computed: {
    ...mapGetters(['currentUser']),
  },
  components: {
    tooltip,
    'ticket-list': TicketList,
  },
  data() {
    return {
      activeTicket: null,
      tinyMce: {
        apiKey: process.env.TINY_MCE_API_KEY,
        contentStyle: '.mce-content-body { color: #ffffff; } html { border-top: 1px solid #242529 }',
        plugins: [
          'wordcount',
          'link',
          'image',
          'lists',
          'codesample',
          'hr',
        ],
        toolbar: 'fontsizeselect | bold italic underline forecolor link | backcolor | image | bullist numlist | hr | codesample | undo redo',
        fontSizes: '10px 11px 12px 13px 14px 16px 18px 24px 36px 48px',
      },
    };
  },
  methods: {
    loadTicket(ticket) {
      this.activeTicket = ticket;
      this.$router.push({ path: `/tickets/view/${ticket._id}` });
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/support/tickets/index.js